import {AppThunk} from '../../index';
import {menuSlice} from '../../../reducers/runtime/menu';

export const setRuntimeMenuState =
  (value: boolean): AppThunk =>
  (dispatch) => {
    dispatch(menuSlice.actions.setMenuState(value));
  };

export const setGoToAppHidden =
  (value: boolean): AppThunk =>
  (dispatch) => {
    dispatch(menuSlice.actions.setGoToAppHidden(value));
  };

export const compareRoutesToHideGoToApp =
  (
    value:
      | {
          key: string;
          index: number;
          routeNames: string[];
          history?: unknown[] | undefined;
          routes: any[];
          type: string;
          stale: false;
        }
      | undefined,
  ): AppThunk =>
  (dispatch) => {
    if (!value) {
      return;
    }

    const drawerInHistory = value.history?.find((item: any) => item.type === 'drawer');
    if (drawerInHistory) {
      return;
    }
    dispatch(menuSlice.actions.setGoToAppHidden(value));
  };

export const toggleRuntimeMenuState = (): AppThunk => (dispatch, getState) => {
  const state = getState();
  dispatch(menuSlice.actions.setMenuState(!state.runtime.menu.isMenuOpen));
};
